// extracted by mini-css-extract-plugin
export default {"root":"kz9NpW","list":"ajOQnM","footer":"cfFnfs"};